import { render, staticRenderFns } from "./EmailForwardersView.vue?vue&type=template&id=a39afc3e&"
import script from "./EmailForwardersView.vue?vue&type=script&lang=js&"
export * from "./EmailForwardersView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a39afc3e')) {
      api.createRecord('a39afc3e', component.options)
    } else {
      api.reload('a39afc3e', component.options)
    }
    module.hot.accept("./EmailForwardersView.vue?vue&type=template&id=a39afc3e&", function () {
      api.rerender('a39afc3e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/services/hosting/shared/email/EmailForwardersView.vue"
export default component.exports